import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-192ccc8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "permantentHeaderBox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "biomarLogo" }, null, -1))
const _hoisted_3 = { "aria-label": "mainNav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_menu_icon = _resolveComponent("menu-icon")!

  return (_openBlock(), _createElementBlock("header", {
    id: "biomarMobileHeader",
    class: _normalizeClass(["navbar", { 'navbar--hidden': _ctx.hideNavbar}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        title: "Biomar GmbH",
        class: "logoWrapper",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeNav()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_menu_icon, {
        class: "menuIcon",
        title: "Navigation menu",
        size: 36,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShowNav()))
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["popupHeaderBox", _ctx.showNav ? 'open-menu' : 'closed-menu'])
    }, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/company",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setShowNav()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Firmenprofil")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/services",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setShowNav()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Leistungen")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/contact",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setShowNav()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Kontakt")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 2)
  ], 2))
}